import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStylesCircle = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      width: '22px',
      height: '22px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    bottom: {
      color: '#757575',
    },
    top: {
      color: '#ffffff',
      animationDuration: '800ms',
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
    },
  }),
)
export default function CircularProgressVariant(props: CircularProgressProps) {
  const classes = useStylesCircle()

  return (
    <div className={classes.root}>
      <CircularProgress
        variant="determinate"
        className={classes.bottom}
        size={22}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        className={classes.top}
        classes={{
          circle: classes.circle,
        }}
        size={22}
        thickness={4}
        {...props}
      />
    </div>
  )
}
